import {
  allMappedHints,
  endpointMatchesScreenHints,
  hintsForScreens,
} from './screenApiHints';

function normalizeRoles(roles) {
  return [...new Set((roles || []).map((r) => String(r || '').trim().toLowerCase()).filter(Boolean))].sort();
}

function toggleRoleOnRow(row, role, shouldHave) {
  const current = normalizeRoles(row.allowed_roles);
  const has = current.includes(role);
  if (shouldHave && !has) return { ...row, allowed_roles: normalizeRoles([...current, role]) };
  if (!shouldHave && has) return { ...row, allowed_roles: current.filter((r) => r !== role) };
  return row;
}

export function toggleScreenRoleWithApiSync(screens, endpoints, screenId, role) {
  const nextScreens = screens.map((s) => {
    if (s.id !== screenId) return s;
    const has = s.allowed_roles.includes(role);
    return {
      ...s,
      allowed_roles: has
        ? s.allowed_roles.filter((r) => r !== role)
        : normalizeRoles([...s.allowed_roles, role]),
    };
  });
  const granted = nextScreens
    .filter((s) => s.allowed_roles.includes(role))
    .map((s) => s.id);
  const needed = hintsForScreens(granted);
  const mapped = allMappedHints();
  const nextEndpoints = endpoints.map((row) => {
    if (!endpointMatchesScreenHints(row.path || '', mapped)) return row;
    return toggleRoleOnRow(row, role, endpointMatchesScreenHints(row.path || '', needed));
  });
  return { screens: nextScreens, endpoints: nextEndpoints };
}

export function setRoleScreensWithApiSync(screens, endpoints, role, screenIds, checked) {
  const idSet = new Set(screenIds);
  const nextScreens = screens.map((s) => {
    if (!idSet.has(s.id)) return s;
    const has = s.allowed_roles.includes(role);
    if (checked && !has) {
      return { ...s, allowed_roles: normalizeRoles([...s.allowed_roles, role]) };
    }
    if (!checked && has) {
      return { ...s, allowed_roles: s.allowed_roles.filter((r) => r !== role) };
    }
    return s;
  });
  const granted = nextScreens
    .filter((s) => s.allowed_roles.includes(role))
    .map((s) => s.id);
  const needed = hintsForScreens(granted);
  const mapped = allMappedHints();
  const nextEndpoints = endpoints.map((row) => {
    if (!endpointMatchesScreenHints(row.path || '', mapped)) return row;
    return toggleRoleOnRow(row, role, endpointMatchesScreenHints(row.path || '', needed));
  });
  return { screens: nextScreens, endpoints: nextEndpoints };
}
